<template>
  <header :class="{scrolled: hideMenu && !menuOpened}">
    <div>
      <router-link to="/" class="logo" :class="{peace: peace}"></router-link>
      <div class="themeswitch tooltip">
        <div class="themetoggle tooltip" @click="toggleTheme">
          <svg class="moon" width="20px" height="20px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg">
            <path
            d="M 43.81 29.354 C 43.688 28.958 43.413 28.626 43.046 28.432 C 42.679 28.238 42.251 28.198 41.854 28.321 C 36.161 29.886 30.067 28.272 25.894 24.096 C 21.722 19.92 20.113 13.824 21.683 8.133 C 21.848 7.582 21.697 6.985 21.29 6.578 C 20.884 6.172 20.287 6.022 19.736 6.187 C 10.659 8.728 4.691 17.389 5.55 26.776 C 6.408 36.163 13.847 43.598 23.235 44.451 C 32.622 45.304 41.28 39.332 43.816 30.253 C 43.902 29.96 43.9 29.647 43.81 29.354 Z"          
            />
          </svg>
          <svg class="sun" width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle class="suncore" cx="11.9998" cy="11.9998" r="5.75375" />
            <g>
              <circle
                cx="3.08982"
                cy="6.85502"
                r="1.71143"
                transform="rotate(-60 3.08982 6.85502)"              
              />
              <circle
                cx="3.0903"
                cy="17.1436"
                r="1.71143"
                transform="rotate(-120 3.0903 17.1436)"
                
              />
              <circle cx="12" cy="22.2881" r="1.71143" />
              <circle
                cx="20.9101"
                cy="17.1436"
                r="1.71143"
                transform="rotate(-60 20.9101 17.1436)"              
              />
              <circle
                cx="20.9101"
                cy="6.8555"
                r="1.71143"
                transform="rotate(-120 20.9101 6.8555)"              
              />
              <circle cx="12" cy="1.71143" r="1.71143" />
            </g>
          </svg>          
        </div>
        <span class="tooltiptext left autohide">Switch theme</span>
      </div>
      <nav id="nav" :class="{opened: menuOpened}">
        <div class="hamburger" @click="menuOpened = !menuOpened">
          <div class="bar1"></div>
          <div class="bar2"></div>
          <div class="bar3"></div>
        </div>

        <div class="links">
          <!-- <a @click="toggleTheme">switch</a>  -->

          <router-link to="/" :class="{active: $route.name === 'Home' && 'router-link-active'}">home<span>.</span></router-link>
          <router-link to="/about" :class="{active: $route.name === 'About' && 'router-link-active'}">about<span>.</span></router-link>
          <router-link to="/prints" :class="{active: $route.name === 'Prints' && 'router-link-active'}">prints<span>.</span></router-link>
          <router-link to="/contact" :class="{active: $route.name === 'Contact' && 'router-link-active'}">contact<span>.</span></router-link>
          <router-link to="/cart" class="cart-button" :class="{active: $route.name === 'Cart' && 'router-link-active', hidden: !showCart}">
            <div class="cart-icon"></div>
            <div class="status-dot" :class="{hidden: !showCart || cartIsEmpty}"></div>       
            <!-- <span class="tooltiptext left autohide">Cart</span>      -->
          </router-link>
        </div>
      </nav>      
    </div>
  </header>
</template>

<script>
import OverlayScrollbars from 'overlayscrollbars';
import { mapState } from 'vuex';
import { mapGetters } from 'vuex';

let logoCycle

export default {
  name: "Header",
  data: function() {
    return {
      menuOpened: false,
      prevScrollPos: 0,
      hideMenu: false,
      peace: false
    };
  },
  watch: {
    '$route' () {
      // react to route changes...
      this.menuOpened = false;
      this.hideMenu = false;
    }
  },
  computed: {
     ...mapState([
      'theme',
    //   // 'showCart',
    //   //'hideMenu',
    //   //'cartFrameModel'
     ]),
    ...mapGetters([
      'cartIsEmpty',
      'showCart',
      // ...
    ])
  },
  methods: {
    toggleTheme(){
      document.documentElement.classList.toggle('dark')
      document.body.classList.toggle('os-theme-light')

      let theme = document.documentElement.classList.contains('dark') ? 'dark' : 'light'
      this.$store.commit('setTheme', theme);

      this.appInsights.trackEvent({name: "ThemeSwitch", properties: {theme: theme}});
    },
    // When the user scrolls down, hide the navbar. When the user scrolls up, show the navbar
    stickyScroll(overlayScrollbars) { 
      // avoid header stuck as hidden when there is no scrollbar needed
      if(window.innerHeight >= document.getElementById('app').offsetHeight){
        this.hideMenu = false
        return
      }      

      let currentScrollPos = (overlayScrollbars ? OverlayScrollbars(document.body).scroll().position.y : window.pageYOffset );
      if(currentScrollPos <= 50)
        return;
      if (this.prevScrollPos > currentScrollPos)
        this.hideMenu = false;
      else 
        this.hideMenu = true;    
      this.prevScrollPos = currentScrollPos;
    }
  },
  mounted: function() {
    this.prevScrollPos = window.pageYOffset;
    window.addEventListener('scroll', this.stickyScroll);
    window.addEventListener('resize', this.stickyScroll);
    if(OverlayScrollbars(document.body))
      OverlayScrollbars(document.body).options("callbacks.onScroll", () => this.stickyScroll(true));
    logoCycle = setInterval(() => this.peace = !this.peace, 10000)
  },
  destroyed: function() {
    //window.removeEventListener('scroll', this.stickyScroll);
    clearInterval(logoCycle)
  }
};
</script>

<style lang="scss">
header {
  height: 50px;
  //position: sticky;
  background-color: var(--color-header);
  position: fixed;
  width: 100%;
  //top: 50px;
  z-index: 200;
  top: 0;
  //box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  box-shadow: var(--shadow-header);  

  > div{
    max-width: $XL;
    margin: 0 auto;
  }

  .tooltip span.tooltiptext{
    padding: 10px;
  }

  &.scrolled {
    top: -50px;
    box-shadow: none;

    .cart-button{
      top: -50px !important;
      transition: all 0.2s ease !important;
    }
  }

  .logo {
    margin: 9px 0 0 0;
    display: block;
    float: left;
    height: 32px;
    width: 140px;
    background: var(--asset-logo) left no-repeat;
    background-size: contain;
    margin-left: 20px;
    transition: all 0.2s ease, background-image 2s ease;

    &.peace{
      background: var(--asset-logo-peace) left no-repeat;
      background-size: contain;
      transition: all 0.2s ease, background-image 2s ease;
    }

    @media (min-width: 340px) {
      width: 150px;
      margin-left: 20px;
    }
    @media (min-width: 370px) {
      width: 160px;
      margin-left: 30px;
    }
    @media (min-width: 440px) {
      width: 180px;      
    }
    @media (min-width: $S) {
      width: 200px;      
    }
  }  

  nav {
    background-color: white;

    @media (min-width: $L) {
      float: right;
      background-color: transparent;
    }

    .hamburger {
      float: right;
      margin-top: 15px;
      cursor: pointer;
      margin-right: 20px;

      @media (min-width: $S) {
        margin-right: 30px;
      }

      @media (min-width: $L) {
        display: none;
      }

      .bar1,
      .bar2,
      .bar3 {
        width: 30px;
        height: 5px;
        margin-top: 2px;
        border-radius: 1px;
        background-color: black;        
      }
    }

    &:not(.opened) .hamburger:hover {
      margin-top: 11px;

      > div {
        margin-top: 4px;
      }
    }

    &.opened {
      .bar1 {
        transform: rotate(-45deg) translate(-5px, 5px);
      }

      .bar2 {
        opacity: 0;
      }

      .bar3 {
        transform: rotate(45deg) translate(-5px, -5px);
      }

      .links {
        max-height: 300px;
        box-shadow: 0 5px 10px -5px rgba(0, 0, 0, 0.1);
      }
    }

    .links {
      position: fixed;
      top: 50px;
      width: 100%;
      background-color: var(--color-header);
      max-height: 0px;
      overflow: hidden;
      @include animate(0.5);

      a {
        display: block;
        margin: 0 40px;
        border-bottom: 1px solid var(--color-cart-countries-hover-bg);
        line-height: 60px;
        text-align: center;
        @include animate(0.5);
        user-select: none;

        &.cart-button{          
          height: 50px;
          width: 40px;
          transition: all 0.5s ease;
          position: fixed;
          top: 2px;
          right: 55px;
          transition: all 0.2s ease !important;
          margin-right: 50px;
          
          @media (min-width: 370px) {
            right: 55px;
          }

          @media (min-width: $S) {
            right: 75px;
          }

          // @media (min-width: $M) {
          //   right: 14%;
          // }

          @media (min-width: $L) {
            position: relative;
            top: unset;
            left: unset;
            right: 12px;
            margin-right: 20px;  

            span.tooltiptext{
              right: calc(3px + 100%);
            }
          }

          &.hidden{
            margin: 0;
            width: 0;  
            height: 0;
            overflow: hidden;
            transition: all 0.5s ease;

            .status-dot{
              opacity: 0;
            }
          }

          .cart-icon{                     
            background: var(--asset-cart-icon-medium) center no-repeat;
            background-size: 70%;
            height: 50px;
            width: 20px;
            padding: 0 10px;              
            
            @media (min-width: $L) {
              opacity: 0.4;
              background: var(--asset-cart-icon) center no-repeat;
              background-size: 50%;
            }
          }

          .status-dot{
            border-radius: 50%;
            border: 4px solid $orange;
            position: absolute;            
            right: 2px;
            top: 10px;

            @media (min-width: $L) {
              right: 5px;
              top: 12px;
            }

            &.hidden{
              opacity: 0;
            }
          }

          &:hover .cart-icon{
            opacity: 1;
            background: var(--asset-cart-icon-medium-hover) center no-repeat;
            background-size: 80%; // 62 if starts from 55
            transition: all 0.2s;

            @media (min-width: $L) {
              background: var(--asset-cart-icon-hover) center no-repeat;
              background-size: 55%; // 60 if starts from 55
            }
          }

          &.active .cart-icon{
            opacity: 1;
          }          
        }

        span{
          color: var(--color-header);
        }

        &:last-child {
          border-bottom: none;
        }

        // &.router-link-exact-active, 
        // &.router-link-exact-active span {
        &.active, 
        &.active span {
          color: var(--color-header-active-text);
          font-weight: bold;
        }

        &:hover,
        // &.router-link-exact-active:hover span {
        &.active:hover span {
          color: $orange;
        }
      }

      @media (min-width: $L) {
        position: static;
        overflow: unset;
        background-color: transparent;

        a{
          line-height: 50px;
          margin: 0 30px 0 10px;
          float: left;
          border: none;
        }

        &.opened links {
          box-shadow: none;
        }
      }
    }    
  }
}


.themeswitch{
  float: right;
  margin-top: 16px;
  margin-right: 15px;

  @media (min-width: $L){
    margin-top: 14px;
  }

  .themetoggle{  
    position: relative;
    width: 20px;
    height: 20px;
    animation: rotateFrom15To0-easeOutElastic 1s forwards;

    svg{
      position: absolute;           
    }   
    
    .sun{
      opacity: 0; 
      fill: var(--color-header-text);  
      .suncore{
        transform: scale(0);
      }     
    } 

    .moon{      
      fill: #dadada;
      transition: all 0.5s 0.1s ease;   
      animation: scale-easeInElastic 1s reverse forwards;           
    } 

    &:hover{
      cursor: pointer;
      //transform: scale(1.5);
      transition: all 0.2s ease;
      animation: rotateLeft15-easeOutElastic 1s forwards;
      transition: none;

      .sun{
        fill: var(--color-header-active-text);
      }

      .moon{
        fill: #a0a0a0;  
        transition: all 0.1s ease;      
      }
    }
  }
}

.dark{ 
  header nav{ 
    .links a.cart-button{ 
      .cart-icon{
        opacity: 0.4;

        &:hover{
          opacity: 1;
          background: var(--asset-cart-icon-medium) center no-repeat;
          background-size: 80%; // 62 if starts from 55

          @media (min-width: $L) {
            background: var(--asset-cart-icon-hover) center no-repeat;
            background-size: 55%; // 60 if starts from 55
          }
        }
      }

      &.active .cart-icon{
        opacity: 1;
      }
    }    

    .hamburger{     
      div{
        background-color: #6b6b6b;    
      }
      &:hover div{
        background-color: white;
      }
    }
  }

  .themetoggle{
    .moon{
      // transform: scale(0);
      // transition: transform 0.1s;
      animation: scale-easeOutElastic 1s forwards;   
    }
    .sun{
      opacity: 1;
      fill: #6b6b6b;
      transition: opacity 0.5s ease;
      animation: rotateLeft15-easeOutElastic 1s 0.1s forwards;

      .suncore{
        transform: scale(1);
        transform-origin: center;
        transition: transform 0.5s ease;
      }
    }

    &:hover{
      .sun{
        transition: none;
        fill: white;
      }
    }
  }
}

@keyframes scale-easeOutElastic {
	0% {
		transform: scale(1);
	}

	16% {
		transform: scale(-0.32);
	}

	28% {
		transform: scale(0.13);
	}

	44% {
		transform: scale(-0.05);
	}

	59% {
		transform: scale(0.02);
	}

	73% {
		transform: scale(-0.01);
	}

	88% {
		transform: scale(0);
	}

	100% {
		transform: scale(0);
	}
}
@keyframes scale-easeInElastic {
	0% {
		transform: scale(1);
	}

	4% {
		transform: scale(1);
	}

	8% {
		transform: scale(1);
	}

	14% {
		transform: scale(1);
	}

	18% {
		transform: scale(1);
	}

	26% {
		transform: scale(1.01);
	}

	28% {
		transform: scale(1.01);
	}

	40% {
		transform: scale(0.98);
	}

	42% {
		transform: scale(0.98);
	}

	56% {
		transform: scale(1.05);
	}

	58% {
		transform: scale(1.04);
	}

	72% {
		transform: scale(0.87);
	}

	86% {
		transform: scale(1.37);
	}

	100% {
		transform: scale(0);
	}

}
@keyframes rotateLeft15-easeOutElastic {
	0% {
		transform: 
      //scale(1) 
      rotate(0deg);
	}
	16% {
		transform: 
      //scale(1.3) 
      rotate(-19.8deg);
	}
	28% {
		transform: 
      //scale(1.05) 
      rotate(-13deg);
	}
	44% {
		transform: 
      //scale(1.1) 
      rotate(-15.7deg);
	}
	59% {
		transform: 
      //scale(1.1) 
      rotate(-14.7);
	}
	73% {
		transform: 
      //scale(1.1) 
      rotate(-14.8deg);
	}
	88% {
		transform: 
      //scale(1.1) 
      rotate(-15deg);
	}
	100% {
		transform: 
      //scale(1.1) 
      rotate(-15deg);
	}
}
@keyframes rotateFrom15To0-easeOutElastic {
	0% {
		transform: rotate(-15deg);
	}
	16% {
		transform: rotate(4.8deg);
	}
	28% {
		transform: rotate(2deg);
	}
	44% {
		transform: rotate(-0.7deg);
	}
	59% {
		transform: rotate(0.3);
	}
	73% {
		transform: rotate(0.2deg);
	}
	88% {
		transform: rotate(0deg);
	}
	100% {
		transform: rotate(0deg);
	}
}

</style>
